import { IListingRequestParams } from "@tm/api-utils";
import mockData from "./mocks/my-partner-listing-mock.json";

/**
 * Mock API response for MyPartner product listing
 * Returns a pre-defined response structure for testing/development purposes
 * Data is hardcoded to avoid external API dependency
 */
export const getMyPartnerMockListing = async (
  reqData: IListingRequestParams
) => {
  return Promise.resolve({
    data: mockData,
  });
};
